module.exports = __webpack_public_path__ + "static/scale-model-of-miami-gardens-florida-51e372c98474144a8cb47ba8f68bba76.png";